import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, output, input } from '@angular/core';

import { IconComponent } from '../icon/icon.component';
import { TruncateComponent } from '../truncate/truncate.component';

@Component({
  selector: 'rt-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.wrap]': 'wrapText()',
    '[class.deletable]': 'deletable()',
    '[class.disabled]': 'disabled()',
    '[class.has-no-left-margin]': 'hasNoLeftMargin()',
    '[class.hoverable]': 'isHoverable()',
    '[class.clickable]': 'isClickable()',
    '[class.avatar]': 'avatar()',
    '[class.error]': 'error()',
  },
  imports: [NgTemplateOutlet, TruncateComponent, IconComponent],
})
export class TagComponent {
  public readonly name = input<string>(undefined!);
  public readonly deletable = input<boolean | undefined>(false);
  public readonly wrapText = input<boolean>();
  public readonly disabled = input<boolean>();
  public readonly error = input<boolean>();
  public readonly hasStopPropagation = input<boolean>(false);
  public readonly hasNoLeftMargin = input<boolean>(false);
  public readonly isHoverable = input<boolean>(true);
  public readonly isClickable = input<boolean>(true);
  public readonly avatar = input<boolean>(false);

  @Input() public counter?: number;
  @Input() public href?: string;
  @Input() public symbolTpl?: TemplateRef<any>;

  public deleteClick = output<string>();

  public deleteTag(event: MouseEvent, tagName: string): void {
    if (this.hasStopPropagation()) {
      event.stopPropagation();
    }
    this.deleteClick.emit(tagName);
  }
}
